(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider, constants) {
        $stateProvider
        .state('survey-result-list', {
            parent: 'app',
            url: '/survey-result-list',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER'],
                pageTitle: 'ipmApp.surveyResult.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-result/survey-result-list.html',
                    controller: 'SurveyResultListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                supportedDataList: ['SurveyResultService', function(SurveyResultService) {
                	return SurveyResultService.getSupportedDataList();
                }]
            },
            params: {
            	searchSurveyResultParamsInfo: null,
                searchPatientParamsInfo: null
            }
        }).state('survey-result-details', {
            parent: 'app',
            url: '/survey-result-details/{id}',
            data: {
                authorities: ['ROLE_STAFF', 'ROLE_MANAGER'],
                pageTitle: 'ipmApp.surveyResult.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/survey-result/survey-result-details.html',
                    controller: 'SurveyResultDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('surveyResult');
                    $translatePartialLoader.addPart('surveyResultStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                surveyResult: ['SurveyResultService', '$stateParams', function(SurveyResultService, $stateParams) {
                	return SurveyResultService.getSurveyResult($stateParams.id);
                }]
            },
            params: {
            	searchSurveyResultParamsInfo: null
            }
        });
    }

})();
